import StoreDefinition from '../StoreDefinition'
import { api } from '../../plugins/axios'

export default new StoreDefinition()
  .prop('material')

  /**
   * Finding the correct material
   */
  .action('find', ({ commit, getters }) => {
    if (getters.material) {
      return Promise.resolve(getters.material)
    }

    return api
      .get('/embed/material')
      .then(material => {
        if (material) {
          commit('setMaterial', material)
        }

        return material
      })
  })

  /**
   * Creates a new material based on the underlying strategy
   */
  .action('create', ({ getters, commit }, materialTypeId) => {
    return api
      .post('/embed/material', {
        materialTypeId
      })
      .then(material => {
        return commit('setMaterial', material)
      })
  })

  /**
   * Saves the briefing content
   */
  .action('saveBriefingContent', ({ getters }, content) => {
    return api.put('/api/v1/embed/material/content', {
      id: getters.material.id,
      content
    })
  })

  /**
   * Finalizes the briefing editing and executes handlers
   */
  .action('finalize', ({ getters }) => {
    return api.post('/api/v1/embed/material/finalize', {
      id: getters.material.id
    })
  })
  .end()
